/* batida-pdp-runtime.js (9.10.2026, Horizon P3): what Pipeline's theme.js (+ Alpine, Flickity, vendor.js) did for the product page,
   written in plain JS for the identical markup (sections/product.liquid + snippets/product-*, copied 1:1 from the live theme
   b2c-redesign @ b5ff7de). Loaded on product pages only (snippets/batida-pdp-assets). No jQuery, no Alpine, no Flickity, no PhotoSwipe
   (the live theme never opened PhotoSwipe on batida.pl either: assets/batida-v7-pgal.js takes the click first).

   Parts, each with its live source in theme.js (line numbers of b5ff7de):
     1  Media          6726-7140   product photo slider (Flickity: fade on desktop, sliding carousel on phones, thumbnails, arrows of the
                                    thumbnail strip, theme:image:change) -> class Slider below, same DOM / classes / inline styles as Flickity
     2  productForm    26836-27130 the Alpine state of .product-page: variantId (custom.js writes it: x-model.fill), quantity, add-to-cart
                                    button states, x-show spans -> initForm()
     3  x-stepper      25782-25890 the quantity stepper (- 1 +, minus disabled at 1, `change` after every change) -> initStepper()
     4  add to cart    batida-drawer.js 445-690: the payload builder (collectMainItem / collectCrossProducts) and the submit handler. On
                                    live the drawer's capture-phase handler does the add and opens the drawer; here the SAME code runs
                                    only while the Batida drawer (P4, window.__batidaDrawerLoaded) is not on the page -> initAtc()
     5  popout-select  3827-4010   option pop-outs of the "artystyczne" template (select-popout__*, data-popout-prevent) -> initPopouts()
     6  Swapper        3235-3275   option name on hover/click -> initSwappers()
     7  share-button   7501-7570   <share-button> -> defineShare()
     8  html.supports-touch (resolution.isTouch)
   Events in the old Pipeline shape that Batida scripts use: theme:image:change (detail.id), theme:cart:change (after an add).
   Stability (D9): the add has a 15 s deadline, a failed bulk add falls back to one request per line (as the live drawer), errors are
   shown in a role=alert line and logged; nothing throws into the page. */
(function () {
  'use strict';
  if (window.__batidaPdpRuntime) return;
  window.__batidaPdpRuntime = true;

  var doc = document, root = doc.documentElement;
  var T = window.theme || {};
  var SIZES = T.sizes || { small: 480, medium: 768, large: 1100 };
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || doc).querySelectorAll(s)); }
  function mq(q) { return window.matchMedia(q).matches; }
  function isMobile() { return mq('(max-width: ' + SIZES.medium + 'px)'); }
  function isTouch() { var t = mq('(any-pointer: coarse)'); root.classList.toggle('supports-touch', t); return t; }
  function fire(el, name, detail, bubbles) { try { el.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: !!bubbles })); } catch (e) {} }
  function safe(name, fn) { try { fn(); } catch (e) { console.warn('[batida-pdp] ' + name + ' failed', e && e.message); } }
  function root_url() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (T.routes && T.routes.root_url) || '/'; return r.replace(/\/$/, ''); }

  /* ================================================================== 1. Slider (the part of Flickity 2 + flickity-fade the PDP used)
     options used by Pipeline: wrapAround true, adaptiveHeight true, prevNextButtons false, pageDots false, accessibility true,
     fade (desktop and the "thumbs" phone layout) or sliding (phone "carousel"), dragThreshold 80 (fade) / 10 (carousel).
     DOM exactly as Flickity builds it: .flickity-viewport > .flickity-slider > .flickity-cell(.is-selected), classes
     flickity-enabled / is-draggable / is-fade on the element, inline transform / opacity / height, aria-hidden on the other cells. */
  function Slider(el, o) {
    var self = this;
    this.el = el; this.o = o; this.ev = {};
    this.cells = $$('.product__media, [data-media-slide]', el).filter(function (c) { return c.parentNode === el; }).map(function (c) { return { element: c }; });
    this.n = this.cells.length;
    this.idx = 0; this.pos = 0; this.off = [];
    this.vp = doc.createElement('div'); this.vp.className = 'flickity-viewport';
    this.sl = doc.createElement('div'); this.sl.className = 'flickity-slider';
    this.cells.forEach(function (c, i) { c.element.classList.add('flickity-cell'); self.sl.appendChild(c.element); self.off[i] = i; });
    this.vp.appendChild(this.sl);
    el.appendChild(this.vp);
    el.classList.add('flickity-enabled');
    if (o.fade) el.classList.add('is-fade');
    el.setAttribute('tabindex', '0');
    this.options = { draggable: o.draggable !== false };
    this.updateDraggable();
    this.vp.style.touchAction = 'pan-y';
    this.place(false);
    this.mark();
    this.resize();
    this.bind();
  }
  Slider.prototype.on = function (n, f) { (this.ev[n] = this.ev[n] || []).push(f); };
  Slider.prototype.emit = function (n, a) { (this.ev[n] || []).forEach(function (f) { try { f(a); } catch (e) { console.warn('[batida-pdp] slider', n, e && e.message); } }); };
  Slider.prototype.updateDraggable = function () { this.el.classList.toggle('is-draggable', !!this.options.draggable); };
  Slider.prototype.mark = function () {
    var self = this;
    this.cells.forEach(function (c, i) {
      var sel = i === self.idx;
      c.element.classList.toggle('is-selected', sel);
      if (sel) c.element.removeAttribute('aria-hidden'); else c.element.setAttribute('aria-hidden', 'true');
    });
  };
  /* where every cell and the slider sit: sliding = cell k at k*100% (shifted by whole laps when wrapping), slider at -pos*100%;
     fade = all cells on top of each other, the selected one opaque */
  Slider.prototype.place = function (animate) {
    var self = this;
    if (this.o.fade) {
      this.sl.style.transform = 'translateX(50%)';
      this.cells.forEach(function (c, i) {
        c.element.style.transform = 'translateX(-50%)';
        if (animate === false) c.element.style.transition = 'none';
        c.element.style.opacity = i === self.idx ? '1' : '0';
        if (animate === false) { void c.element.offsetWidth; c.element.style.transition = 'opacity .3s ease'; }
      });
      return;
    }
    this.cells.forEach(function (c, i) { c.element.style.transform = 'translateX(' + (self.off[i] * 100) + '%)'; });
    this.sl.style.transition = animate === false ? 'none' : 'transform .35s cubic-bezier(.25,.8,.25,1)';
    this.sl.style.transform = 'translateX(' + (-this.pos * 100) + '%)';
  };
  Slider.prototype.setHeight = function () {
    var c = this.cells[this.idx]; if (!c) return;
    var h = c.element.getBoundingClientRect().height; if (h) this.vp.style.height = h + 'px'; /* Flickity: cell.size.outerHeight, fractional */
  };
  Slider.prototype.resize = function () { this.setHeight(); };
  /* select cell i (wrap-around: the shortest way round) */
  Slider.prototype.select = function (i, instant) {
    var n = this.n; if (!n) return;
    var cur = this.idx, target;
    if (this.o.wrap) i = ((i % n) + n) % n; else i = Math.max(0, Math.min(n - 1, i));
    if (i === this.idx && !instant) { this.setHeight(); return; }
    if (!this.o.fade) {
      var delta = i - cur;
      if (this.o.wrap) { if (delta > n / 2) delta -= n; else if (delta < -n / 2) delta += n; }
      target = this.pos + delta;
      var self = this;
      this.cells.forEach(function (c, k) {
        /* keep a cell where it is while it stays within half a lap of the target (no visible jump), else bring it to the nearest lap */
        if (k === i) self.off[k] = target;
        else if (self.o.wrap && Math.abs(self.off[k] - target) > n / 2) self.off[k] = k + n * Math.round((target - k) / n);
      });
      this.pos = target;
    }
    this.idx = i;
    this.mark();
    this.place(instant ? false : true);
    this.setHeight();
    this.emit('change', i);
    var self2 = this;
    clearTimeout(this.settleT);
    this.settleT = setTimeout(function () { self2.emit('settle', i); }, instant ? 0 : 380);
  };
  Slider.prototype.next = function () { this.select(this.idx + 1); };
  Slider.prototype.previous = function () { this.select(this.idx - 1); };
  Slider.prototype.bind = function () {
    var self = this, el = this.el, vp = this.vp, dragging = false, down = null, moved = false;
    this.h = {};
    this.h.key = function (e) {
      if (e.target !== el) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.previous(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
    };
    el.addEventListener('keydown', this.h.key);
    /* drag: pointer events, only horizontal; a drag is never a click (capture) */
    function pd(e) {
      if (!self.options.draggable || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (e.target.closest && e.target.closest('video, model-viewer, button, a')) { if (e.target.closest('video, model-viewer')) return; }
      down = { x: e.clientX, y: e.clientY, t: Date.now(), pos: self.pos, id: e.pointerId };
      moved = false; dragging = false;
      el.classList.add('is-pointer-down');
    }
    function pm(e) {
      if (!down || e.pointerId !== down.id) return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if (!dragging) {
        if (Math.abs(dx) < Math.min(self.o.dragThreshold || 3, 10) || Math.abs(dx) < Math.abs(dy)) return;
        dragging = true; moved = true;
        try { vp.setPointerCapture(e.pointerId); } catch (x) {}
        if (!self.o.fade) {
          /* put the neighbour on the side the finger pulls to */
          var nb = dx < 0 ? self.idx + 1 : self.idx - 1, k = ((nb % self.n) + self.n) % self.n;
          if (self.o.wrap && k !== self.idx) self.off[k] = self.pos + (dx < 0 ? 1 : -1);
          self.cells.forEach(function (c, j) { c.element.style.transform = 'translateX(' + (self.off[j] * 100) + '%)'; });
          self.sl.style.transition = 'none';
        }
      }
      if (dragging && !self.o.fade) {
        self.sl.style.transform = 'translateX(calc(' + (-self.pos * 100) + '% + ' + dx + 'px))';
      }
    }
    function pu(e) {
      if (!down || (e && e.pointerId !== down.id)) return;
      var dx = (e ? e.clientX : down.x) - down.x, dt = Math.max(1, Date.now() - down.t), w = vp.clientWidth || 1;
      el.classList.remove('is-pointer-down');
      var d = down; down = null;
      if (!dragging) return;
      dragging = false;
      try { vp.releasePointerCapture(d.id); } catch (x) {}
      var fast = Math.abs(dx) / dt > 0.4, far = Math.abs(dx) > (self.o.fade ? (self.o.dragThreshold || 80) : w * 0.2);
      if ((fast && Math.abs(dx) > 10) || far) { if (dx < 0) self.next(); else self.previous(); }
      else { self.place(true); }
    }
    vp.addEventListener('pointerdown', pd);
    vp.addEventListener('pointermove', pm);
    vp.addEventListener('pointerup', pu);
    vp.addEventListener('pointercancel', pu);
    this.h.click = function (e) { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } };
    vp.addEventListener('click', this.h.click, true);
    this.h.resize = function () { clearTimeout(self.rt); self.rt = setTimeout(function () { self.resize(); }, 60); };
    window.addEventListener('resize', this.h.resize);
    /* images that arrive later change the height of the cell */
    $$('img', this.sl).forEach(function (im) { if (!im.complete) im.addEventListener('load', self.h.resize, { once: true }); });
    window.addEventListener('load', this.h.resize, { once: true });
  };
  Slider.prototype.destroy = function () {
    var el = this.el, self = this;
    el.removeEventListener('keydown', this.h.key);
    window.removeEventListener('resize', this.h.resize);
    this.cells.forEach(function (c) {
      c.element.classList.remove('flickity-cell', 'is-selected');
      c.element.removeAttribute('aria-hidden'); c.element.style.transform = ''; c.element.style.opacity = ''; c.element.style.transition = '';
      el.appendChild(c.element);
    });
    if (this.vp.parentNode) this.vp.parentNode.removeChild(this.vp);
    el.classList.remove('flickity-enabled', 'is-draggable', 'is-fade', 'is-pointer-down');
    el.removeAttribute('tabindex');
    void self;
  };

  /* ================================================================== 1b. Media: the slider + thumbnails (theme.js class Media) */
  function initMedia(container) {
    var slideshow = $('[data-product-slideshow]', container);
    if (!slideshow) return;
    var mobileStyle = slideshow.getAttribute('data-slideshow-mobile-style') || 'none';
    var desktopStyle = slideshow.getAttribute('data-slideshow-desktop-style') || 'none';
    var arrowPrev = $('[data-thumbs-arrow-prev]', container), arrowNext = $('[data-thumbs-arrow-next]', container);
    var thumbWrapper = $('[data-product-thumbs]', container);
    var thumbImages = $$('[data-slideshow-thumbnail]', container);
    var verticalAlignment = !!$('[data-thumbnails-left]', container);
    var flkty = null, hasMobile = false, hasDesktop = false, lastMediaSelect = null, thumbsHolder = null;

    function updateDraggable(state) {
      if (!flkty) return;
      flkty.options.draggable = state; flkty.updateDraggable();
      slideshow.classList.toggle('enable-video-draggable', state);
    }
    function setDraggable() {
      /* images only (the shop has no videos / 3D models on products): always draggable */
      updateDraggable(true);
    }
    /* thumbnail strip scrolling (Media.scrollThumbs / checkThumbPositions / toggleToActiveThumb / toggleArrows) */
    function scrollThumbs(event) {
      var thumbs = $('[data-product-thumbs]', container);
      if (!thumbs) return;
      var thumb = $('.is-activated', thumbs), items = $$('[data-slideshow-thumbnail]', container);
      var last = items[items.length - 1];
      if (!thumb || !last) return;
      var sT = thumbs.scrollTop, sL = thumbs.scrollLeft, tW = thumbs.offsetWidth;
      var tH = slideshow.offsetWidth / thumb.getAttribute('data-aspect-ratio');
      var posBottom = sT + tH, posRight = sL + tW;
      var w = thumb.offsetWidth, h = thumb.offsetHeight, pT = thumb.offsetTop, pL = thumb.offsetLeft;
      var lastRight = last.offsetLeft + w, lastBottom = last.offsetTop + h;
      var scrollTop = pT + h / 2 - tH / 2, scrollLeft = pL + w / 2 - tW / 2;
      var topCheck = sT > 0, bottomCheck = posBottom < lastBottom, leftCheck = sL > 0, rightCheck = posRight < lastRight;
      var vertical = bottomCheck || topCheck, horizontal = rightCheck || leftCheck;
      if (event !== 'scroll') {
        if (event === 'clickPrev') { if (vertical) { scrollTop = sT - tH; scrollLeft = 0; } else { scrollTop = 0; scrollLeft = sL - tW; } }
        if (event === 'clickNext') { if (vertical) { scrollTop = sT + tH; scrollLeft = 0; } else { scrollTop = 0; scrollLeft = sL + tW; } }
        thumbs.scrollTo({ top: scrollTop, left: scrollLeft, behavior: 'smooth' });
      }
      if (arrowPrev && arrowNext) {
        if (vertical || (verticalAlignment && !vertical)) { arrowPrev.classList.toggle('show', topCheck); arrowNext.classList.toggle('show', bottomCheck); }
        if (horizontal || (!verticalAlignment && !horizontal)) { arrowPrev.classList.toggle('show', leftCheck); arrowNext.classList.toggle('show', rightCheck); }
      }
    }
    function onChange(index) {
      var cell = flkty.cells[index].element;
      slideshow.classList.remove('flickity-lock-height');
      var id = cell.getAttribute('data-media-id');
      var cur = thumbWrapper && thumbWrapper.querySelector('[data-media-select="' + id + '"]');
      var act = thumbWrapper && thumbWrapper.querySelector('.is-activated');
      if (act) act.classList.remove('is-activated');
      if (cur) cur.classList.add('is-activated');
      scrollThumbs();
    }
    function onSettle() { setDraggable(); scrollThumbs(); }
    function onImageChange(e) {
      var id = String(e.detail && e.detail.id); lastMediaSelect = id;
      var i = -1;
      flkty.cells.forEach(function (c, k) { if (i < 0 && c.element.getAttribute('data-media-id') === id) i = k; });
      if (i >= 0) flkty.select(i);
      scrollThumbs();
    }
    function thumbClick(e) { fire(slideshow, 'theme:image:change', { id: e.currentTarget.getAttribute('data-media-select') }); }
    function create(opts) {
      flkty = new Slider(slideshow, opts);
      setDraggable();
      flkty.on('change', onChange);
      flkty.on('settle', onSettle);
      slideshow.addEventListener('theme:image:change', onImageChange);
      thumbImages.forEach(function (t) { t.addEventListener('click', thumbClick); });
      if (arrowPrev) arrowPrev.addEventListener('click', clickPrev);
      if (arrowNext) arrowNext.addEventListener('click', clickNext);
      if (thumbWrapper) thumbWrapper.addEventListener('scroll', onThumbScroll);
    }
    function clickPrev() { scrollThumbs('clickPrev'); }
    function clickNext() { scrollThumbs('clickNext'); }
    function onThumbScroll() { scrollThumbs('scroll'); }
    function destroy() {
      slideshow.removeEventListener('theme:image:change', onImageChange);
      thumbImages.forEach(function (t) { t.removeEventListener('click', thumbClick); });
      if (arrowPrev) arrowPrev.removeEventListener('click', clickPrev);
      if (arrowNext) arrowNext.removeEventListener('click', clickNext);
      if (thumbWrapper) thumbWrapper.removeEventListener('scroll', onThumbScroll);
      flkty.destroy(); flkty = null;
    }
    function build() {
      if (isMobile()) {
        if (hasDesktop && flkty) { destroy(); hasDesktop = false; }
        if (flkty) return;
        var mo = { wrap: true, fade: true, dragThreshold: 80 };
        if (mobileStyle === 'carousel') { mo.fade = false; mo.dragThreshold = 10; }
        if (mobileStyle === 'slideshow') { mo.fade = false; mo.dragThreshold = 10; }
        if (mobileStyle === 'none') return;
        create(mo); hasMobile = true;
      } else {
        if (hasMobile && flkty) { destroy(); hasMobile = false; }
        if (flkty) return;
        if (desktopStyle === 'none') return;
        create({ wrap: true, fade: true, dragThreshold: 80 }); hasDesktop = true;
      }
      isTouch();
      scrollThumbs();
    }
    build();
    window.matchMedia('(max-width: ' + SIZES.medium + 'px)').addEventListener('change', function () { safe('slider rebuild', build); });
    doc.addEventListener('theme:resize:width', function () { scrollThumbs(); });
    thumbsHolder = $('[data-thumbs-holder]', container);
    /* the initial variant picture (data-initial-variant-media-id) is selected after the slider exists (productForm.init) */
    var section = container.closest('[data-section-type]') || container;
    var first = section.getAttribute && section.getAttribute('data-initial-variant-media-id');
    if (first && flkty) fire(slideshow, 'theme:image:change', { id: first });
    return { thumbsHolder: thumbsHolder };
  }

  /* ================================================================== 2. productForm state, 3. stepper */
  function initForm(rootEl) {
    var form = $('form[data-product-form]', rootEl) || $('form', rootEl);
    var idInput = $('input[name="id"]', rootEl);
    var qtyInput = $('input[name="quantity"]', rootEl);
    var btn = $('[data-add-to-cart]', rootEl) || $('.btn--add-to-cart', rootEl);
    /* custom.js (v18 PriceSync) writes the chosen variant to the Alpine state: root._x_dataStack[0].variantId = id; x-model.fill then put it
       into the hidden input. Same contract, no Alpine. */
    var state = { isLoading: false, isSuccess: false, error: '' };
    Object.defineProperty(state, 'variantId', { get: function () { return idInput ? Number(idInput.value) : null; }, set: function (v) { if (idInput && v != null) idInput.value = v; }, enumerable: true });
    Object.defineProperty(state, 'quantity', { get: function () { return qtyInput ? Number(qtyInput.value) || 1 : 1; }, enumerable: true });
    rootEl._x_dataStack = [state];
    /* x-show spans: hidden until a state shows them */
    var shows = {};
    $$('[x-show]', rootEl).forEach(function (s) { shows[s.getAttribute('x-show')] = s; s.style.display = 'none'; });
    function paint() {
      if (btn) { btn.classList.toggle('loading', state.isLoading); btn.classList.toggle('has-success', state.isSuccess); }
      if (shows.isLoading) shows.isLoading.style.display = state.isLoading ? '' : 'none';
      if (shows.isSuccess) shows.isSuccess.style.display = state.isSuccess ? '' : 'none';
    }
    rootEl._batidaForm = { state: state, paint: paint, form: form, btn: btn };
    /* x-text on [data-button-price]: "<price> x quantity", re-drawn when the quantity changes */
    var pr = $('[data-button-price]', rootEl), basePrice = null;
    if (pr) { var m = (pr.getAttribute('x-text') || '').match(/batidaMoney\(\s*(\d+)\s*\*/); if (m) basePrice = Number(m[1]); }
    function drawPrice() {
      if (!pr || basePrice == null || !window.batidaMoney) return;
      pr.textContent = window.batidaMoney(basePrice * Math.max(state.quantity, 1));
    }
    var st = $('[x-stepper]', rootEl);
    if (st) initStepper(st, drawPrice);
    return rootEl._batidaForm;
  }
  function initStepper(st, onValue) {
    var inp = st.querySelector('[x-stepper\\:input]'), minus = st.querySelector('[x-stepper\\:minus]'), plus = st.querySelector('[x-stepper\\:plus]');
    if (!inp) return;
    var min = Number(inp.min), max = inp.max ? Number(inp.max) : null;
    var last = Number(inp.value) || 0;
    function val() { return Number(inp.value) || 0; }
    function sync() { if (minus) minus.disabled = min === val(); if (plus) plus.disabled = max !== null && max === val(); }
    function changed() {
      var v = val(); sync();
      if (v !== last) { last = v; if (onValue) onValue(v); inp.dispatchEvent(new CustomEvent('change', { bubbles: true, composed: true, cancelable: true })); }
    }
    if (minus) minus.addEventListener('click', function (e) { e.preventDefault(); if (inp.disabled) return; inp.stepDown(); changed(); });
    if (plus) plus.addEventListener('click', function (e) { e.preventDefault(); if (inp.disabled) return; inp.stepUp(); changed(); });
    inp.addEventListener('input', changed);
    st.addEventListener('click', function (e) { if (e.target === st) inp.focus(); });
    sync();
  }

  /* ================================================================== 4. add to cart (only while the Batida drawer is not loaded) */
  function collectMainItem(form) {
    var fd = new FormData(form), id = fd.get('id'), quantity = parseInt(fd.get('quantity'), 10) || 1, properties = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) properties[m[1]] = v; });
    try {
      ['#batida-napis-text', '#bp_text'].forEach(function (sel) {
        var el = doc.querySelector(sel);
        if (!(!el || form.contains(el))) {
          var pv = (el.value || '').trim();
          if (pv) { var pm = (el.name || '').match(/^properties\[(.+)\]$/); if (pm && !properties[pm[1]]) properties[pm[1]] = pv; }
        }
      });
    } catch (e) {}
    var item = { id: id, quantity: quantity };
    if (Object.keys(properties).length > 0) item.properties = properties;
    return item;
  }
  function collectCrossProducts() {
    var items = [];
    $$('.cross-product').forEach(function (cp) {
      var cb = cp.querySelector('.cross-product__checkbox') || cp.querySelector('input[type="checkbox"]');
      if (!cb || !cb.checked) return;
      var variantId = cb.getAttribute('data-variant-id');
      if (!variantId) return;
      var properties = {};
      var msgEl = doc.querySelector('textarea[name="properties[_Message-Wiadomosc]"]');
      var candlesEl = doc.querySelector('.cross-product__input-text--candles');
      var isLetterCp = msgEl && (cp.contains(msgEl) || (msgEl.closest('.batida-perso-expanded') && msgEl.closest('.batida-perso-expanded').previousElementSibling === cp));
      var isCandlesCp = candlesEl && (cp.contains(candlesEl) || (candlesEl.closest('.batida-perso-expanded') && candlesEl.closest('.batida-perso-expanded').previousElementSibling === cp));
      if (!isLetterCp && !isCandlesCp) {
        var handle = '';
        (cp.className || '').split(/\s+/).forEach(function (c) { var m = c.match(/^cross-product--(.+)$/); if (m) handle = m[1]; });
        var ch = cp.getAttribute('data-canonical-handle');
        if (ch) handle = ch;
        if (handle === 'napisz-swoj-list') isLetterCp = !!msgEl; else if (handle === 'swieczka-cyferka') isCandlesCp = !!candlesEl;
      }
      if (isLetterCp && msgEl && msgEl.value) properties.message = msgEl.value;
      if (isCandlesCp && candlesEl && candlesEl.value) properties.candles = candlesEl.value;
      if (isCandlesCp && Array.isArray(window.__batidaCandleSelections) && window.__batidaCandleSelections.length > 0 && window.__batidaCandleVariantMap) {
        var sel = window.__batidaCandleSelections, vmap = window.__batidaCandleVariantMap, grouped = {};
        sel.forEach(function (d) { grouped[d] = (grouped[d] || 0) + 1; });
        Object.keys(grouped).forEach(function (d) {
          var v = vmap[d];
          if (v && v.id) items.push({ id: parseInt(v.id, 10), quantity: grouped[d], properties: { candles: sel.join('') } });
        });
        return;
      }
      var qtyInp = (function () {
        var ch2 = cp.getAttribute('data-canonical-handle') || ((cp.className || '').match(/cross-product--(\S+)/) || [])[1];
        var r = ch2 && doc.querySelector('.batida-perso-row[data-handle="' + ch2 + '"]');
        var ex = r && r.nextElementSibling;
        return ex && ex.querySelector('.cross-product__input');
      })();
      var qty = qtyInp ? Math.max(1, parseInt(qtyInp.value, 10) || 1) : 1;
      var item = { id: parseInt(variantId, 10), quantity: qty };
      if (Object.keys(properties).length > 0) item.properties = properties;
      items.push(item);
    });
    return items;
  }
  /* the same builders for P4 / tests: window.batidaPdpAtcItems(form) -> the exact items[] the live drawer posts */
  window.batidaPdpAtcItems = function (form) { return [collectMainItem(form)].concat(collectCrossProducts()); };

  function drawerError(rootEl, msg) {
    var box = rootEl && rootEl.querySelector('[data-error-display]');
    if (!box) return;
    box.innerHTML = msg ? '<div class="errors"></div>' : '';
    if (msg) box.firstChild.textContent = msg;
  }
  function addTimeout(url, opts, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var tm = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} }, ms);
    opts.signal = ctl ? ctl.signal : undefined;
    return fetch(url, opts).then(function (r) { clearTimeout(tm); return r; }, function (e) { clearTimeout(tm); throw e; });
  }
  function afterAdd(rootEl, fb) {
    var read = window.batidaCart && window.batidaCart.read ? window.batidaCart.read() : fetch(root_url() + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    return read.then(function (cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      /* until the Batida drawer (P4) exists: the same small bar the product cards use (batida-v7-card.js, P2) */
      if (window.batidaCartToast) window.batidaCartToast();
      fb.state.isSuccess = true; fb.paint();
      setTimeout(function () { fb.state.isSuccess = false; fb.paint(); }, 3500);
    }).catch(function (e) { console.warn('[batida-pdp] cart read after add failed', e && e.message); });
  }
  function initAtc() {
    doc.body.addEventListener('submit', function (e) {
      if (window.__batidaDrawerLoaded) return;              /* P4: the drawer's own capture handler adds and opens */
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-product-form][action$="/cart/add"]')) return;
      if (form.getAttribute('data-batida-bypass') === '1') return;
      var rootEl = form.closest('[x-data="productForm()"]') || doc;
      var fb = rootEl._batidaForm || { state: {}, paint: function () {} };
      var atc = form.querySelector('.btn--add-to-cart, button[name="add"]');
      if (atc && atc.disabled) { e.preventDefault(); return; }
      e.preventDefault(); e.stopPropagation();
      if (fb.state.isLoading) return;
      fb.state.isLoading = true; fb.paint(); if (atc) atc.classList.add('is-loading');
      drawerError(rootEl, '');
      var items = [collectMainItem(form)].concat(collectCrossProducts());
      var done = function () { fb.state.isLoading = false; fb.paint(); if (atc) atc.classList.remove('is-loading'); };
      addTimeout(root_url() + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }, 15000)
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { throw new Error(j.description || j.message || 'Add to cart failed'); }); })
        .then(function () { done(); return afterAdd(rootEl, fb); })
        .catch(function (err) {
          console.error('[batida-pdp] ATC error:', err);
          /* as the live drawer: one request per line, so a sold-out add-on does not block the cake */
          var failed = 0, p = Promise.resolve();
          items.forEach(function (it) {
            p = p.then(function () {
              return addTimeout(root_url() + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [it] }) }, 15000)
                .then(function (r) { if (!r.ok) failed++; }, function () { failed++; });
            });
          });
          return p.then(function () {
            done();
            if (failed === items.length) { fb.state.error = (err && err.message) || ''; drawerError(rootEl, fb.state.error); return null; }
            if (failed > 0) drawerError(rootEl, (window.batidaT && window.batidaT('cart_drawer.addon_unavailable', 'Niektóre produkty nie były już dostępne i nie zostały dodane do koszyka.')) || '');
            return afterAdd(rootEl, fb);
          });
        });
    }, true);
  }

  /* ================================================================== 5. option pop-outs of the product form (artystyczne template) */
  function initPopouts() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-popout][data-popout-prevent="true"] [data-popout-option]');
      if (!a || a.getAttribute('href') !== '#') return;
      var wrap = a.closest('[data-popout]'), list = wrap.querySelector('[data-popout-list]'), input = wrap.querySelector('[data-popout-input]'), toggle = wrap.querySelector('[data-popout-toggle]');
      e.preventDefault(); e.stopImmediatePropagation();
      var v = a.getAttribute('data-value') || '';
      input.value = v;
      input.dispatchEvent(new Event('change'));
      var cur = list.querySelector('[class*="--current"]');
      var cls = 'select-popout__item--current';
      if (cur) { for (var i = 0; i < cur.classList.length; i++) { if (cur.classList[i].indexOf('--current') > -1) { cls = cur.classList[i]; break; } } }
      var old = list.querySelector('.' + cls);
      if (old) { old.classList.remove(cls); a.parentElement.classList.add(cls); }
      var ac = list.querySelector('[aria-current]');
      if (ac) { ac.removeAttribute('aria-current'); a.setAttribute('aria-current', 'true'); }
      if (v !== '') { [].forEach.call(toggle.childNodes, function (n) { if (n.nodeType === 3) n.textContent = v; }); }
      list.classList.remove('popout-list--visible');
      toggle.setAttribute('aria-expanded', 'false');
    }, true);
  }

  /* ================================================================== 6. Swapper: the option name follows hover / click */
  function initSwappers(container) {
    $$('[data-swapper-wrapper]', container).forEach(function (el) {
      var target = $('[data-swapper-target]', el), hovers = $$('[data-swapper-hover]', el);
      if (!target || !hovers.length) return;
      var def = target.innerHTML;
      hovers.forEach(function (h) {
        h.addEventListener('mouseenter', function () { target.innerHTML = '' + h.getAttribute('data-swapper-hover'); });
        h.addEventListener('mouseleave', function () { target.innerHTML = def; });
        h.addEventListener('click', function () { def = '' + h.getAttribute('data-swapper-hover'); });
      });
    });
  }

  /* ================================================================== 7. <share-button> */
  function defineShare() {
    if (!window.customElements || customElements.get('share-button')) return;
    customElements.define('share-button', class ShareButton extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('[data-section-type]') || doc;
        this.details = this.querySelector('[data-share-details]');
        this.btn = this.querySelector('[data-share-button]');
        this.copy = this.querySelector('[data-share-copy]');
        this.summary = this.querySelector('[data-share-summary]');
        this.closeBtn = this.querySelector('[data-close-button]');
        this.msg = this.querySelector('[data-success-message]');
        this.urlInput = this.querySelector('[data-share-url]');
        this.url = this.urlInput ? this.urlInput.value : doc.location.href;
        var self = this;
        if (navigator.share) {
          this.details.classList.add('is-hidden'); this.btn.classList.remove('is-hidden');
          this.btn.addEventListener('click', function () { navigator.share({ url: self.url, title: doc.title }); });
        } else {
          this.details.addEventListener('toggle', function () {
            if (!self.details.open) { self.msg.classList.add('is-hidden'); self.msg.textContent = ''; self.closeBtn.classList.add('is-hidden'); self.copy.focus(); }
          });
          this.details.addEventListener('focusout', function () { setTimeout(function () { if (!self.contains(doc.activeElement)) self.close(); }); });
          this.copy.addEventListener('click', function () {
            navigator.clipboard.writeText(self.urlInput.value).then(function () {
              self.msg.classList.remove('is-hidden'); self.msg.textContent = (T.strings && T.strings.successMessage) || '';
              self.closeBtn.classList.remove('is-hidden'); self.closeBtn.focus();
            });
          });
          this.closeBtn.addEventListener('click', function () { self.close(); });
          this.container.addEventListener('keyup', function (e) { if (e.code === 'Escape' && self.details.open) { self.close(); self.summary.focus(); } });
        }
      }
      close() { this.details.removeAttribute('open'); this.summary.setAttribute('aria-expanded', false); }
    });
  }

  /* ================================================================== start */
  function start() {
    isTouch();
    defineShare();
    initPopouts();
    var section = $('[data-section-type="product"]');
    var formRoot = $('[x-data="productForm()"]');
    if (formRoot) safe('form', function () { initForm(formRoot); });
    initAtc();
    if (section) {
      safe('media', function () { initMedia(section); });
      safe('swappers', function () { initSwappers(section); });
    }
    window.batidaPdp = { collectMainItem: collectMainItem, collectCrossProducts: collectCrossProducts };
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
